module.exports = __webpack_public_path__ + "img/avatar1.105f242d.svg";